export default __webpack_public_path__ + "static/media/img-engine-room-selected.7c126fa5.svg";